var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"ma-2"},[_c('v-card-title',[_vm._v("活動修改")]),_c('v-card-text',[_c('v-divider'),_c('item-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }